<template>
  <div>Calendar</div>
</template>

<script>
export default {
  components: {},
  name: 'Teams-Calendar',

  // mounted() {},
  computed: {},
  methods: {}
};
</script>

<style></style>
